<!-- Page Header Section -->
<mat-toolbar class="page-header">
  <div class="menu-container">
    <!-- Page Title -->
    <div>
      <div class="menu-title">External Voucher Management</div>
    </div>

    <!-- Header Button Menu -->
    <div class="button-group">

      <!-- Download Excel Template Button -->
      <button mat-flat-button color="primary" (click)="onDownloadTemplateClick()">
        Download Template
      </button>

      <!-- Upload Excel File Button -->
      <button mat-flat-button color="primary" (click)="onUploadExcelClick()">
        Upload
      </button>

    </div>
  </div>
</mat-toolbar>

<!-- Page Body Section -->
<div class="content-container">
  <!-- Listing Top Menu Bar -->
  <div class="content-sub-header">

    <!-- Listing Filter Section -->
    <div class="filter-container">

      <!-- Filter 1: Free Text Filter -->
      <mat-form-field appearance="outline" floatLabel="never" class="filter-wrapper">
        <input matInput placeholder="Search here..." autocomplete="off" [formControl]="searchText" />
        <button *ngIf="searchText.value" mat-icon-button matSuffix class="clear-field-btn"
          (click)="onTextFilterClear()">
          <mat-icon>close</mat-icon>
        </button>
      </mat-form-field>

      <!-- Filter 3: Voucher Status DropDown Filter -->
       <mat-form-field appearance="outline" floatLabel="never" class="filter-wrapper">
        <mat-select multiple [(ngModel)]="selectedVouchersStatuses" (ngModelChange)="onSelectionFilterOptionChange()">
          <mat-select-trigger>
            {{ getMultiFilterLabel("voucherStatus") }}
          </mat-select-trigger>
          <mat-option>
            <ngx-mat-select-search placeholderLabel="Search status here" [ngModelOptions]="{ standalone: true }"
              [searching]="!availableVoucherStatuses.length" [showToggleAllCheckbox]="true"
              (toggleAll)="toggleSelectAll($event, 'voucherStatus')"
              [toggleAllCheckboxChecked]="isSelectedAll('voucherStatus')"
              [toggleAllCheckboxIndeterminate]="isSelectedOptionsIndeterminate('voucherStatus')"
              (ngModelChange)="onSelectSearchChange($event, 'voucherStatus')"
              noEntriesFoundLabel="No matching voucher status found" ngModel ngDefaultControl>
            </ngx-mat-select-search>
          </mat-option>
          <mat-option *ngFor="let item of filteredVoucherStatuses" [value]="item">
            {{ item }}
          </mat-option>
        </mat-select>
        <button mat-icon-button matSuffix class="clear-field-btn" *ngIf="!isSelectedAll('voucherStatus')"
          (click)="onResetFilteredOption($event, 'voucherStatus')">
          <mat-icon>close</mat-icon>
        </button>
       </mat-form-field>

    </div>

    <!-- Listing Button Menu -->
    <div class="button-group">

      <!-- Bulk Deactivate Button -->
      <button appCheckFunctionPermission mat-flat-button color="primary" class="custom-button"
        (click)="onBulkDeactivateClick()">
        Bulk Deactivate
      </button>

      <!-- Export Excel Button -->
      <button appCheckFunctionPermission mat-flat-button color="primary" class="custom-button"
        (click)="onExportListingClick()">
        Export to Excel
      </button>

    </div>

  </div>

  <!-- Listing Table -->
  <mat-card class="card-table">
    <div class="table-container">
      <table mat-table [dataSource]="list" matSort matSortActive="createdDate" matSortDirection="asc"
        matSortDisableClear (matSortChange)="onSortChange($event)">
        <ng-container matColumnDef="createdDate">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            Creation Date
          </th>
          <td mat-cell *matCellDef="let element" class="sm-col">
            {{ element.createdDate | date : "dd MMM yyyy" }}
            <br />
            {{ element.createdDate | date : "hh:mm aa" }}
          </td>
        </ng-container>

        <ng-container matColumnDef="voucherPIN">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            Voucher PIN
          </th>
          <td mat-cell *matCellDef="let element" class="md-col">
            {{ element.voucherPIN || "-" }}
          </td>
        </ng-container>
        
        <ng-container matColumnDef="expiryDate">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            Expiry Date
          </th>
          <td mat-cell *matCellDef="let element" class="sm-col">
            {{ element.expiryDate ? (element.expiryDate | date: 'dd MMM yyyy') : '-' }}
          </td>
        </ng-container>

        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            Status
          </th>
          <td mat-cell *matCellDef="let element" class="md-col">
            <div [ngSwitch]="element.status">
              <span class="cover-label green" *ngSwitchCase="'Active'">
                Active
              </span>
              <span class="cover-label red" *ngSwitchCase="'Deactivated'">
                Deactivated
              </span>
              <span class="cover-label" *ngSwitchCase="'Claimed'">
                Claimed
              </span>
              <span class="cover-label orange" *ngSwitchCase="'Expired'">
                Expired
              </span>
          </div>
        </td>
        </ng-container>

        <ng-container matColumnDef="vehicleNo">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            Vehicle No.
          </th>
          <td mat-cell *matCellDef="let element" class="md-col">
            {{ element.vehicleNo || "-" }}
          </td>
        </ng-container>

        <ng-container matColumnDef="action">
          <th mat-header-cell *matHeaderCellDef>
            Deactivate
          </th>
          <td mat-cell *matCellDef="let element" class="sm-col">
            <button *ngIf="element.status == 'Active'" mat-icon-button (click)="onItemDeactivateClick($event, element);">
              <mat-icon>remove_circle_outline</mat-icon>
            </button>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>

        <tr *matNoDataRow>
          <td class="mat-cell" colspan="9999">
            <app-empty-record *ngIf="list.length === 0" [disableSubTitle]="true">
            </app-empty-record>
            <app-skeleton-loader></app-skeleton-loader>
          </td>
        </tr>
      </table>
    </div>
    <mat-divider></mat-divider>

    <mat-paginator [pageSizeOptions]="[50, 100, 150]" [pageSize]="limit" [length]="length" (page)="onPageChange($event)"
      aria-label="Select page of users"></mat-paginator>
  </mat-card>
</div>